"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.PolyFills = void 0;
var _function = require("./type-checks/function.js");
const PolyFills = () => {
  if (!(0, _function.isFunction)(Object.hasOwn)) {
    Object.hasOwn = (obj, prop) => Object.prototype.hasOwnProperty.call(obj, prop);
  }
};
exports.PolyFills = PolyFills;
PolyFills();